import defaults from "lodash/defaults";
import wrap from "lodash/wrap";
import isFunction from "lodash/isFunction";
import defer from "lodash/defer";

// ## `addHandlerWrapper`
//
// Go through statics.analyticsActions and parse any entries that have a
// `handler` key. For each of them, apply `_.wrap()` to the original function
// to call an analytics callback before the original function is called.
export function addHandlerWrappers() {
  if (this.constructor.analyticsActions) {
    defer(() => {
      this.constructor.analyticsActions
        .filter((options) => options.handler)
        .forEach((options) => {
          defaults(options, {
            passOriginalArguments: true,
          });
          const { handler, action, filter, passOriginalArguments } = options;
          this[handler] = wrap(
            this[handler],
            (originalFunction, ...originalArguments) => {
              const argumentsToSend = passOriginalArguments
                ? originalArguments
                : [];
              if (!filter || filter.call(this, this.props, this.state)) {
                const func = isFunction(action)
                  ? action
                  : require("../index").AnalyticsActions[action];
                if (!isFunction(func)) {
                  throw new Error("could not find analytics action function");
                }
                func.call(null, this.props, this.state, ...argumentsToSend);
              }

              // Call the original function with the original arguments.
              originalFunction.call(this, ...originalArguments);
            },
          );
        }, this);
    });
  }
}

export default addHandlerWrappers;
